import React from 'react';
import PropTypes from 'prop-types';

import { texts } from 'utils/languages/fr';

import { CustomDialogTitle, PDFViewer } from 'components';
import { Box, Dialog, DialogContent, Link } from '@mui/material';
import { useSmallScreen } from 'utils/hooks/ui';

const PDFDialog = ({ url, title, open, onClose, ...rest }) => {
    const fullScreen = useSmallScreen();

    return (
        <Dialog
            fullScreen={fullScreen}
            sx={theme => ({ [theme.breakpoints.down('sm')]: { minWidth: 'unset' } })}
            open={open}
            maxWidth="xl"
            {...rest}
        >
            <CustomDialogTitle handleClose={onClose} title={title} />
            <DialogContent sx={{ padding: '30px' }}>
                <PDFViewer url={url} />
                <Box textAlign="center" p={1}>
                    <Link
                        href={url}
                        download
                        target="_blank"
                        rel="noreferrer"
                        sx={{
                            color: 'common.black',
                            textDecoration: 'none',
                            '&:hover': { color: 'primary.main', textDecoration: 'underline' },
                        }}
                    >
                        {texts.DOWNLOAD_DOCUMENT}
                    </Link>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

PDFDialog.propTypes = {
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default PDFDialog;
